export const fileOwnerTypes = {
  Insured: 0,
  InsuredVisible: 1,
  MGA: 2,
  Prospect: 3,
  Carrier: 4,
  Finance_Company: 5,
  Referral_Source: 6,
  Other_Insured: 7,

  Policy: 8,

  // should be used for everything related to insured (lower in object hierarchy)
  InsuredNote: 9,

  Task: 10,

  Agency: 11,

  InsuredDefaultFolderStructure: 12,
  PolicyDefaultFolderStructure: 13,

  Agent: 14,

  AgencyNote: 15,

  AgentNote: 16,

  AgencyTrainingMaterials: 17,

  Opportunity: 18,

  OpportunityNote: 19,

  Claim: 20,

  ServiceRequest: 21,
};
